module.exports = __webpack_public_path__ + "img/icoPrizeGropuTtl.236388c0.png";